import React from "react";
import { View, Text, TouchableOpacity, StyleSheet, Image, Linking, Platform } from "react-native";
import config from '../config';
import AddressIcon from './../assets/icons/address.svg';
import RefundSuccessIcon from './../assets/icons/refund_success.svg';
import RefundFailedIcon from './../assets/icons/refund_failed.svg';
import I18n from '../utils/i18n';
import CustomChip from "./CustomChip";
import { formatPriceWithCurrencyCode } from "../utils/common";

let payrexx_status_icon;

if (Platform.OS === 'web') {
    payrexx_status_icon = {
        'refund_success' : <Image source={require('./../assets/icons/refund_success.svg')} style={{width: 30, height: 30}} />,
        'refund_failed' : <Image source={require('./../assets/icons/refund_failed.svg')} style={{width: 30, height: 30}} />
    }
} else {
    payrexx_status_icon = {
        'refund_success' : <RefundSuccessIcon width={30} height={30} />,
        'refund_failed' : <RefundFailedIcon width={30} height={30} />,
    }
}

class OrderDetailsCard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(nextProps, nextState) {
        nextState = {
            ...nextState,
            ...nextProps
        }
    }

    openGps = (lat, lng, title = null) => {
        const scheme = Platform.select({ ios: 'maps:0,0?q=', android: 'geo:0,0?q=' });
        const latLng = `${lat},${lng}`;
        const label = title ? title : latLng;
        const url = Platform.select({
            ios: `${scheme}${label}@${latLng}`,
            android: `${scheme}${latLng}(${label})`,
            web: `https://www.google.com/maps/search/?api=1&query=${latLng}`
        });    
        Linking.openURL(url);
    }

    isPaymentOptionAvailable(paymentType, paymentMethod) {
        return this.props?.availablePaymentOptions.find((item) => (item.paymentType == paymentType && item.paymentMethod == paymentMethod));
    }
    
    render() {
        return (
            <View
                style={{backgroundColor: 'white', padding: 10, paddingTop: 10, paddingBottom: 10, margin: 5, flex: 1, flexDirection: 'column', borderRadius: 7}}
            >

                <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20}}>
                    <View style={{justifyContent: 'center'}}>
                        <View>
                            {/* show only last 6 digits of id */}
                            <Text style={{fontWeight: '700', fontSize: 17, marginTop: 5, color: 'black'}}>
                                {this.props?.id ? I18n.t('order_id') + ': ' + this.props.id.slice(-6).toUpperCase() : null}
                            </Text>
                            {(this.props?.beeperNumber) ? (
                                <Text style={{fontWeight: '700', fontSize: 17, color: 'black'}}>
                                    {I18n.t('beeper_number') + ': ' + this.props.beeperNumber}
                                </Text>
                            ) : null}
                            {((this.props?.role == config.roles.CASHIER.key || this.props?.role == config.roles.SERVER.key) && this.props?.user) ? (
                                <Text style={{color: 'black', fontSize: 23, fontWeight: '600'}}>{this.props?.user?.fullname}</Text>
                            ) : null}
                        </View>
                    </View>
                    <View>
                        {(this.props?.orderNumber) ? (
                            <View style={{borderRadius: 25, borderColor: config.primaryColor, borderWidth: 2}}>
                                <Text style={{fontWeight: '700', fontSize: 25, padding: 10, color: 'black'}}>
                                    {this.props.orderNumber}
                                </Text>
                            </View>
                        ) : null}
                    </View>
                </View>

                <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                    <View style={{flexDirection: 'row'}}>
                        {(this.props?.status == config.orderStatus.CANCELLED.key && this.props?.payrexxStatus == "refunded") && (
                            payrexx_status_icon['refund_success']
                        )}
                        {(this.props?.status == config.orderStatus.CANCELLED.key && this.props?.payrexxStatus != "refunded") && (
                            payrexx_status_icon['refund_failed']
                        )}
                    </View>
                    <View style={{justifyContent: 'center'}}>
                        {this.props?.status == config.orderStatus.PAYMENT_PENDING.key ? 
                            <CustomChip text={config.orderStatus.PAYMENT_PENDING.name} backgroundColor={"white"} color={"orange"} borderColor={"orange"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.WAITING_FOR_PAYMENT.key ? 
                            <CustomChip text={config.orderStatus.WAITING_FOR_PAYMENT.name} backgroundColor={"orange"} color={"white"} borderColor={"orange"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.PAYMENT_FAILED.key ? 
                            <CustomChip text={config.orderStatus.PAYMENT_FAILED.name} backgroundColor={"white"} color={"red"} borderColor={"red"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.PENDING.key ? 
                            <CustomChip text={config.orderStatus.PENDING.name} /> 
                        : null}
                        {this.props?.status == config.orderStatus.CONFIRMED.key ? 
                            <CustomChip text={config.orderStatus.CONFIRMED.name} /> 
                        : null}
                        {this.props?.status == config.orderStatus.PROCESSING.key ? 
                            <CustomChip text={config.orderStatus.PROCESSING.name} backgroundColor={"orange"} color={"white"} borderColor={"orange"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.READY.key ? 
                            <CustomChip text={config.orderStatus.READY.name} backgroundColor={"white"} color={"green"} borderColor={"green"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.COMPLETED.key ? 
                            <CustomChip text={config.orderStatus.COMPLETED.name} backgroundColor={"green"} color={"white"} borderColor={"green"} /> 
                        : null}
                        {this.props?.status == config.orderStatus.CANCELLED.key ? 
                            <CustomChip text={config.orderStatus.CANCELLED.name} backgroundColor={"red"} color={"white"} borderColor={"red"} /> 
                        : null}
                    </View>
                </View>

                {(!this.props.history) ? (

                    <>
                        {(this.props?.role == config.roles.CASHIER.key || this.props?.role == config.roles.SERVER.key) ? (
                            // If status is pending, then show the button to confirm the order
                            <View style={{marginTop: 10}}>
                                {this.props?.status == config.orderStatus.PENDING.key ? (
                                    <View style={{marginBottom: 10}}>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'green', padding: 10, borderRadius: 5, paddingTop: 25, paddingBottom: 25, marginBottom: 20}}
                                            onPress={() => this.props.onConfirmOrder(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 25, textAlign: 'center'}}>{I18n.t('confirm_order')}</Text>
                                        </TouchableOpacity>
                                    </View>
                                ) : null}
                                {this.props?.status == config.orderStatus.CONFIRMED.key ? (
                                    <View style={{marginBottom: 10}}>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'green', padding: 10, borderRadius: 5, paddingTop: 25, paddingBottom: 25, marginBottom: 20}}
                                            onPress={() => this.props.onProcessOrder(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 25, textAlign: 'center'}}>{I18n.t('process_order')}</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'orange', padding: 10, borderRadius: 5, marginTop: 5}}
                                            onPress={() => this.props.onOrderPending(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 15, textAlign: 'center'}}>{I18n.t('step_back')}</Text>
                                        </TouchableOpacity>
                                    </View>
                                ) : null}
                                {this.props?.status == config.orderStatus.PROCESSING.key ? (
                                    <View style={{marginBottom: 10}}>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'green', padding: 10, borderRadius: 5, paddingTop: 25, paddingBottom: 25, marginBottom: 20}}
                                            onPress={() => this.props.onOrderReady(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 25, textAlign: 'center'}}>{I18n.t('order_ready')}</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'orange', padding: 10, borderRadius: 5, marginTop: 5}}
                                            onPress={() => this.props.onConfirmOrder(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 15, textAlign: 'center'}}>{I18n.t('step_back')}</Text>
                                        </TouchableOpacity>
                                    </View>
                                ) : null}
                                {this.props?.status == config.orderStatus.READY.key ? (
                                    <View style={{marginBottom: 10}}>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'green', padding: 10, borderRadius: 5, paddingTop: 25, paddingBottom: 25, marginBottom: 20}}
                                            onPress={() => this.props.onCompleteOrder(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 25, textAlign: 'center'}}>{I18n.t('complete_order')}</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'orange', padding: 10, borderRadius: 5, marginTop: 5}}
                                            onPress={() => this.props.onProcessOrder(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 15, textAlign: 'center'}}>{I18n.t('step_back')}</Text>
                                        </TouchableOpacity>
                                    </View>
                                ) : null}
                                {this.props?.status == config.orderStatus.COMPLETED.key ? (
                                    <View style={{marginBottom: 10}}>
                                        <TouchableOpacity
                                            style={{backgroundColor: 'orange', padding: 10, borderRadius: 5, marginTop: 5}}
                                            onPress={() => this.props.onOrderReady(this.props.id)}
                                        >
                                            <Text style={{color: 'white', fontWeight: '700', fontSize: 15, textAlign: 'center'}}>{I18n.t('step_back')}</Text>
                                        </TouchableOpacity>
                                    </View>
                                ) : null}
                            </View>
                        ) : null}

                    </>
                ) : null}

                {this.props?.secondary_title ? (
                    <View>
                        <Text style={{fontSize: 15, marginTop: 5, marginBottom: 5, color: 'black'}}>{this.props?.secondary_title}</Text>
                    </View>
                ) : null}
                
                
                {this.props?.description ? (
                    <View>
                        <Text style={{fontSize: 14, marginTop: 5, marginBottom: 1, color: 'gray', fontWeight: '600', textAlign: 'right'}}>{this.props?.description}</Text>
                    </View>
                ) : null}

                {/* Pay for just this order */}
                {((this.props?.onPayNow) && (this.props?.role == config.roles.USER.key)) ? (
                    <View style={{flex: 1, flexDirection: 'row', marginBottom: 20}}>
                        {((!this.props?.history) && (this.props?.status == config.orderStatus.PAYMENT_PENDING.key || this.props?.status == config.orderStatus.WAITING_FOR_PAYMENT.key || this.props?.status == config.orderStatus.PAYMENT_FAILED.key)) ? (
                            <>
                                <TouchableOpacity
                                    style={
                                        Platform.OS == 'web' ?
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 20, width: '100%'} :
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 10, width: '100%'}
                                    }
                                    onPress={() => {
                                        this.props?.onPayNow(config.paymentType.ONLINE.key)
                                    }}
                                    disabled={this.props?.payingNow}
                                >
                                    <Text style={{color: 'white', fontSize: 20, fontWeight: '700'}}>
                                        {(this.props?.payingNow) ? I18n.t('loading') : (
                                            (this.props?.role == config.roles.USER.key) ? I18n.t('pay_for_this_order_ticket') : I18n.t('online_payment')
                                        )}
                                    </Text>
                                </TouchableOpacity>
                            </>
                        ) : null}
                    </View>
                ) : null}
                
                {/* Pay for Order Group */}
                {((this.props?.onPayOrderGroupNow) && (this.props?.role == config.roles.USER.key)) ? (
                    <>
                    {(this.props?.availablePaymentOptions.find((item) => (item.paymentType == config.paymentType.ONLINE.key && item.paymentMethod == config.paymentMethod.PAYREXX.key))) ? (
                    <View style={{flex: 1, flexDirection: 'row', marginBottom: 20}}>
                        {((!this.props?.history) && (this.props?.status == config.orderStatus.PAYMENT_PENDING.key || this.props?.status == config.orderStatus.WAITING_FOR_PAYMENT.key || this.props?.status == config.orderStatus.PAYMENT_FAILED.key)) ? (
                            <>
                                <TouchableOpacity
                                    style={
                                        Platform.OS == 'web' ?
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 20, width: '100%'} :
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 10, width: '100%'}
                                    }
                                    onPress={() => {
                                        if (this.props?.role == config.roles.USER.key) {
                                            this.props?.onPayOrderGroupNow(config.paymentType.ONLINE.key, config.paymentMethod.PAYREXX.key)
                                        } else {
                                            this.props?.onPayOrderGroupNow(config.paymentType.CARD.key)
                                        }

                                    }}
                                    disabled={this.props?.payingNow}
                                >
                                    <Text style={{color: 'white', fontSize: 20, fontWeight: '700', textAlign: 'center'}}>
                                        {(this.props?.payingNow) ? I18n.t('loading') : (
                                            ((this.props?.role == config.roles.USER.key) ? ((this.isPaymentOptionAvailable(config.paymentType.ONLINE.key, config.paymentMethod.TWINT.key) ? I18n.t('pay_for_full_order_by_card') : I18n.t('pay_for_full_order'))) : I18n.t('online_payment')) +
                                            (this.props?.orderGroup?.grandTotal ? ' : ' + formatPriceWithCurrencyCode(this.props.orderGroup.grandTotal, this.props?.currencyCode) : '')
                                        )}
                                    </Text>
                                </TouchableOpacity>
                            </>
                        ) : null}
                    </View>
                    ) : null}
                    {(this.props?.availablePaymentOptions.find((item) => (item.paymentType == config.paymentType.ONLINE.key && item.paymentMethod == config.paymentMethod.TWINT.key))) ? (
                    <View style={{flex: 1, flexDirection: 'row', marginBottom: 20}}>
                        {((!this.props?.history) && (this.props?.status == config.orderStatus.PAYMENT_PENDING.key || this.props?.status == config.orderStatus.WAITING_FOR_PAYMENT.key || this.props?.status == config.orderStatus.PAYMENT_FAILED.key)) ? (
                            <>
                                <TouchableOpacity
                                    style={
                                        Platform.OS == 'web' ?
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 20, width: '100%'} :
                                        {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: (this.props?.payingNow ? 'gray' : config.primaryColor), borderRadius: 10, padding: 10, width: '100%'}
                                    }
                                    onPress={() => {
                                        this.props?.onPayOrderGroupNow(config.paymentType.ONLINE.key, config.paymentMethod.TWINT.key)
                                    }}
                                    disabled={this.props?.payingNow}
                                >
                                    <Text style={{color: 'white', fontSize: 20, fontWeight: '700', textAlign: 'center'}}>
                                        {(this.props?.payingNow) ? I18n.t('loading') : (
                                            ((this.props?.role == config.roles.USER.key) ? I18n.t('pay_for_full_order_by_twint') : I18n.t('online_payment')) +
                                            (this.props?.orderGroup?.grandTotal ? ' : ' + formatPriceWithCurrencyCode(this.props.orderGroup.grandTotal, this.props?.currencyCode) : '')
                                        )}
                                    </Text>
                                </TouchableOpacity>
                            </>
                        ) : null}
                    </View>
                    ) : null}
                    </>
                ) : null}

                {this.props?.consumptions?.map((consumption, index) => {
                    return (
                        <View key={index}>
                            <View style={{flex: 1, justifyContent: 'space-between', flexDirection: 'row', marginTop: 3}}>
                                <View style={{justifyContent: 'center'}}>
                                    <Text style={{fontSize: 23, fontWeight: '600', color: 'black'}}>
                                        <Text style={{fontSize: 32, fontWeight: '600', color: 'red'}}>{consumption.quantity}</Text>
                                        <Text>{' x ' + consumption.name}</Text>
                                    </Text>
                                </View>
                            </View>
                            <View style={{flex: 1, justifyContent: 'space-between', flexDirection: 'row', marginBottom: 3}}>
                                <Text style={{color: 'gray', fontWeight: '600'}}>{formatPriceWithCurrencyCode(consumption?.price, this.props?.currencyCode)}</Text>
                                <View style={{justifyContent: 'flex-end'}}>
                                    <Text style={{fontSize: 20, fontWeight: '600', color: 'black'}}>{(formatPriceWithCurrencyCode(consumption?.total, this.props?.currencyCode))}</Text>
                                </View>
                            </View>
                        </View>
                    )
                })}

                <View style={{flex: 1, alignItems: 'flex-end', borderTopWidth: 3}}>
                    <Text style={{fontWeight: '700', fontSize: 25, marginTop: 5, marginBottom: 5, color: 'black'}}>{formatPriceWithCurrencyCode(this.props?.total, this.props?.currencyCode)}</Text>
                </View>

                {/* Cancel order for cashier */}
                {(this.props?.role == config.roles.CASHIER.key && this.props?.paymentType != config.paymentType.CARD.key) ? (
                    <View>
                        {(
                            this.props?.status == config.orderStatus.PENDING.key ||
                            this.props?.status == config.orderStatus.CONFIRMED.key || 
                            this.props?.status == config.orderStatus.PROCESSING.key ||
                            this.props?.status == config.orderStatus.READY.key ||
                            this.props?.status == config.orderStatus.COMPLETED.key
                        ) ? (
                            <TouchableOpacity
                                style={{backgroundColor: config.dangerColor, padding: 10, borderRadius: 5, width: '100%'}}
                                onPress={() => this.props.onCancelOrder(this.props.id)}
                            >
                                <Text style={{color: 'white', fontWeight: '700', fontSize: 15, textAlign: 'center'}}>{I18n.t('cancel_order')}</Text>
                            </TouchableOpacity>
                        ) : null}
                    </View>
                ) : null}


                {(this.props?.address || this.props?.geo_location) ? (
                    <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between', marginTop: 10, alignItems: 'stretch'}}>
                        {this.props?.address ? (
                            <View style={{justifyContent: 'center', width: '70%'}}>
                                <Text style={{color: 'black'}}>{this.props?.address?.addressLine1}</Text>
                            </View>
                        ) : <View></View>}
                        {this.props?.geo_location ? (
                            <View style={{justifyContent: 'center', align: 'right'}}>
                                <TouchableOpacity
                                    style={{width: 60, height: 40, borderRadius: 10, backgroundColor: config.primaryColor, justifyContent: 'center', alignItems: 'center'}}
                                    onPress={() => this.openGps(this.props?.geo_location?.latitude, this.props?.geo_location?.longitude)}
                                >
                                    {(Platform.OS === 'web') ? (
                                        <Image source={require('./../assets/icons/address.svg')} style={{width: 20, height: 20}} />
                                    ) : (
                                        <AddressIcon width={20} height={20} />
                                    )}
                                </TouchableOpacity>
                            </View>
                        ) : null}
                        
                    </View>
                ) : null}

            </View>
        );
    }
}

const styles = StyleSheet.create({
    navigation_button_text: {
        color: 'gray'
    },
    buttonGroup: {
        height: 50,
        padding: 5,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        // backgroundColor: config.primaryColor,
        borderColor: 'rgba(255, 255, 255, 1)',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
        borderWidth: 2,
    },
    wideTouchableButton: {
        // backgroundColor: 'rgba(8, 96, 126, 0.15)',
        backgroundColor: config.primaryColor,
        borderColor: 'rgba(255, 255, 255, 0.8)',
        // margin: 10,
        borderRadius: 10,
        flexDirection: "row",
        justifyContent: 'center',
        alignItems: 'center',
        // width: 80,
        paddingLeft: 20,
        paddingRight: 20,
        height: 40
        // borderWidth: 3,
    },
    touchableButton: {
        // backgroundColor: 'rgba(8, 96, 126, 0.15)',
        backgroundColor: config.primaryColor,
        borderColor: 'rgba(255, 255, 255, 0.8)',
        // margin: 10,
        borderRadius: 10,
        flexDirection: "row",
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40
        // borderWidth: 3,
    },
    wideButtonText: {
        fontSize: 20,
        // color: 'rgba(8, 96, 126, 1)',
        color: 'white'
    },
    buttonText: {
        fontSize: 29,
        // color: 'rgba(8, 96, 126, 1)',
        color: 'white'
    },
    count:{
        fontSize: 22,
        paddingLeft: 5,
        paddingRight: 5,
        width: 40,
        textAlign: 'center',
        color: 'black'
    },
    addButtonGroup: {
        // backgroundColor: 'rgba(8, 96, 126, 0.15)',
        backgroundColor: config.primaryColor,
        borderColor: 'rgba(255, 255, 255, 0.8)',
        // margin: 10,
        borderRadius: 10,
        flexDirection: "row",
        justifyContent: 'center',
        alignItems: 'center',
        // width: 120,
        // height: 40
    },
    buttonView: {
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        margin: 5
    },
    addText: {
        fontSize: 18,
        fontWeight: '500',
        color: 'white'
    }
});

export default OrderDetailsCard;